import { defineComponent } from 'vue';

export default defineComponent({
  name: 'home-slider',
  computed: {
    wheelBrandsRoute(){
      return this.$route.name === "ssw-wheels" ? "1" : this.$route.name === "diesel-wheels" ? "2" : this.$route.name === "flotec-wheels" ? "3" : "0";
    }
  }
});